// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/agents_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { ContentUpdates, Note } from "./notes_pb.ts";
import { AccountStub } from "./common_pb.ts";
import { DocumentType } from "./documents_pb.ts";

/**
 * @generated from message protogen.AgentPrompt
 */
export class AgentPrompt extends Message<AgentPrompt> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string type = 2;
   */
  type = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string status = 4;
   */
  status = "";

  /**
   * @generated from field: int64 creationSec = 6;
   */
  creationSec = protoInt64.zero;

  /**
   * @generated from field: int64 updatedSec = 7;
   */
  updatedSec = protoInt64.zero;

  /**
   * @generated from field: protogen.Note content = 8;
   */
  content?: Note;

  /**
   * @generated from field: protogen.AccountStub owner = 9;
   */
  owner?: AccountStub;

  /**
   * @generated from field: string scope = 10;
   */
  scope = "";

  /**
   * @generated from field: bool isEnabledForUser = 11;
   */
  isEnabledForUser = false;

  /**
   * @generated from field: string configurationJson = 12;
   */
  configurationJson = "";

  /**
   * @generated from field: bool clientOutputVisible = 13;
   */
  clientOutputVisible = false;

  constructor(data?: PartialMessage<AgentPrompt>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AgentPrompt";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "creationSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "updatedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "content", kind: "message", T: Note },
    { no: 9, name: "owner", kind: "message", T: AccountStub },
    { no: 10, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "isEnabledForUser", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "configurationJson", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "clientOutputVisible", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentPrompt {
    return new AgentPrompt().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentPrompt {
    return new AgentPrompt().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentPrompt {
    return new AgentPrompt().fromJsonString(jsonString, options);
  }

  static equals(a: AgentPrompt | PlainMessage<AgentPrompt> | undefined, b: AgentPrompt | PlainMessage<AgentPrompt> | undefined): boolean {
    return proto3.util.equals(AgentPrompt, a, b);
  }
}

/**
 * @generated from message protogen.StartAgentRequest
 */
export class StartAgentRequest extends Message<StartAgentRequest> {
  /**
   * @generated from field: string agentType = 1;
   */
  agentType = "";

  /**
   * @generated from field: repeated protogen.StartAgentRequest.StartAgentArgument arguments = 2;
   */
  arguments: StartAgentRequest_StartAgentArgument[] = [];

  /**
   * @generated from field: string model = 3;
   */
  model = "";

  constructor(data?: PartialMessage<StartAgentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.StartAgentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "agentType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "arguments", kind: "message", T: StartAgentRequest_StartAgentArgument, repeated: true },
    { no: 3, name: "model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartAgentRequest {
    return new StartAgentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartAgentRequest {
    return new StartAgentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartAgentRequest {
    return new StartAgentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StartAgentRequest | PlainMessage<StartAgentRequest> | undefined, b: StartAgentRequest | PlainMessage<StartAgentRequest> | undefined): boolean {
    return proto3.util.equals(StartAgentRequest, a, b);
  }
}

/**
 * @generated from message protogen.StartAgentRequest.StartAgentArgument
 */
export class StartAgentRequest_StartAgentArgument extends Message<StartAgentRequest_StartAgentArgument> {
  /**
   * taskRef, familyRef, emailRef, etc
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string value = 2;
   */
  value = "";

  constructor(data?: PartialMessage<StartAgentRequest_StartAgentArgument>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.StartAgentRequest.StartAgentArgument";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartAgentRequest_StartAgentArgument {
    return new StartAgentRequest_StartAgentArgument().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartAgentRequest_StartAgentArgument {
    return new StartAgentRequest_StartAgentArgument().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartAgentRequest_StartAgentArgument {
    return new StartAgentRequest_StartAgentArgument().fromJsonString(jsonString, options);
  }

  static equals(a: StartAgentRequest_StartAgentArgument | PlainMessage<StartAgentRequest_StartAgentArgument> | undefined, b: StartAgentRequest_StartAgentArgument | PlainMessage<StartAgentRequest_StartAgentArgument> | undefined): boolean {
    return proto3.util.equals(StartAgentRequest_StartAgentArgument, a, b);
  }
}

/**
 * @generated from message protogen.StartAgentResponse
 */
export class StartAgentResponse extends Message<StartAgentResponse> {
  /**
   * @generated from field: string threadRef = 1;
   */
  threadRef = "";

  constructor(data?: PartialMessage<StartAgentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.StartAgentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartAgentResponse {
    return new StartAgentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartAgentResponse {
    return new StartAgentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartAgentResponse {
    return new StartAgentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StartAgentResponse | PlainMessage<StartAgentResponse> | undefined, b: StartAgentResponse | PlainMessage<StartAgentResponse> | undefined): boolean {
    return proto3.util.equals(StartAgentResponse, a, b);
  }
}

/**
 * @generated from message protogen.AnswerAgentQuestionRequest
 */
export class AnswerAgentQuestionRequest extends Message<AnswerAgentQuestionRequest> {
  /**
   * @generated from field: string threadRef = 1;
   */
  threadRef = "";

  /**
   * @generated from field: repeated protogen.AnswerAgentQuestionRequest.Answer answers = 2;
   */
  answers: AnswerAgentQuestionRequest_Answer[] = [];

  /**
   * @generated from field: string model = 3;
   */
  model = "";

  constructor(data?: PartialMessage<AnswerAgentQuestionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AnswerAgentQuestionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "answers", kind: "message", T: AnswerAgentQuestionRequest_Answer, repeated: true },
    { no: 3, name: "model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AnswerAgentQuestionRequest {
    return new AnswerAgentQuestionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AnswerAgentQuestionRequest {
    return new AnswerAgentQuestionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AnswerAgentQuestionRequest {
    return new AnswerAgentQuestionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AnswerAgentQuestionRequest | PlainMessage<AnswerAgentQuestionRequest> | undefined, b: AnswerAgentQuestionRequest | PlainMessage<AnswerAgentQuestionRequest> | undefined): boolean {
    return proto3.util.equals(AnswerAgentQuestionRequest, a, b);
  }
}

/**
 * @generated from message protogen.AnswerAgentQuestionRequest.Answer
 */
export class AnswerAgentQuestionRequest_Answer extends Message<AnswerAgentQuestionRequest_Answer> {
  /**
   * @generated from field: string text = 1;
   */
  text = "";

  /**
   * @generated from field: string functionId = 2;
   */
  functionId = "";

  constructor(data?: PartialMessage<AnswerAgentQuestionRequest_Answer>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AnswerAgentQuestionRequest.Answer";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "functionId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AnswerAgentQuestionRequest_Answer {
    return new AnswerAgentQuestionRequest_Answer().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AnswerAgentQuestionRequest_Answer {
    return new AnswerAgentQuestionRequest_Answer().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AnswerAgentQuestionRequest_Answer {
    return new AnswerAgentQuestionRequest_Answer().fromJsonString(jsonString, options);
  }

  static equals(a: AnswerAgentQuestionRequest_Answer | PlainMessage<AnswerAgentQuestionRequest_Answer> | undefined, b: AnswerAgentQuestionRequest_Answer | PlainMessage<AnswerAgentQuestionRequest_Answer> | undefined): boolean {
    return proto3.util.equals(AnswerAgentQuestionRequest_Answer, a, b);
  }
}

/**
 * @generated from message protogen.AnswerAgentQuestionResponse
 */
export class AnswerAgentQuestionResponse extends Message<AnswerAgentQuestionResponse> {
  /**
   * @generated from field: string threadRef = 1;
   */
  threadRef = "";

  constructor(data?: PartialMessage<AnswerAgentQuestionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AnswerAgentQuestionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AnswerAgentQuestionResponse {
    return new AnswerAgentQuestionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AnswerAgentQuestionResponse {
    return new AnswerAgentQuestionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AnswerAgentQuestionResponse {
    return new AnswerAgentQuestionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AnswerAgentQuestionResponse | PlainMessage<AnswerAgentQuestionResponse> | undefined, b: AnswerAgentQuestionResponse | PlainMessage<AnswerAgentQuestionResponse> | undefined): boolean {
    return proto3.util.equals(AnswerAgentQuestionResponse, a, b);
  }
}

/**
 * @generated from message protogen.AgentMessageRequest
 */
export class AgentMessageRequest extends Message<AgentMessageRequest> {
  /**
   * @generated from field: string threadRef = 1;
   */
  threadRef = "";

  /**
   * @generated from field: protogen.ContentUpdates body = 2;
   */
  body?: ContentUpdates;

  /**
   * @generated from field: string model = 3;
   */
  model = "";

  /**
   * @generated from field: bool hideFromChat = 4;
   */
  hideFromChat = false;

  constructor(data?: PartialMessage<AgentMessageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AgentMessageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "body", kind: "message", T: ContentUpdates },
    { no: 3, name: "model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "hideFromChat", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentMessageRequest {
    return new AgentMessageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentMessageRequest {
    return new AgentMessageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentMessageRequest {
    return new AgentMessageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AgentMessageRequest | PlainMessage<AgentMessageRequest> | undefined, b: AgentMessageRequest | PlainMessage<AgentMessageRequest> | undefined): boolean {
    return proto3.util.equals(AgentMessageRequest, a, b);
  }
}

/**
 * @generated from message protogen.AgentMessageResponse
 */
export class AgentMessageResponse extends Message<AgentMessageResponse> {
  /**
   * @generated from field: string threadRef = 1;
   */
  threadRef = "";

  constructor(data?: PartialMessage<AgentMessageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AgentMessageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AgentMessageResponse {
    return new AgentMessageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AgentMessageResponse {
    return new AgentMessageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AgentMessageResponse {
    return new AgentMessageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AgentMessageResponse | PlainMessage<AgentMessageResponse> | undefined, b: AgentMessageResponse | PlainMessage<AgentMessageResponse> | undefined): boolean {
    return proto3.util.equals(AgentMessageResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetAgentsThreadRequest
 */
export class GetAgentsThreadRequest extends Message<GetAgentsThreadRequest> {
  /**
   * @generated from field: string threadRef = 1;
   */
  threadRef = "";

  /**
   * @generated from field: bool includeAdminMessageHistory = 2;
   */
  includeAdminMessageHistory = false;

  constructor(data?: PartialMessage<GetAgentsThreadRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAgentsThreadRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "includeAdminMessageHistory", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentsThreadRequest {
    return new GetAgentsThreadRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentsThreadRequest {
    return new GetAgentsThreadRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentsThreadRequest {
    return new GetAgentsThreadRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentsThreadRequest | PlainMessage<GetAgentsThreadRequest> | undefined, b: GetAgentsThreadRequest | PlainMessage<GetAgentsThreadRequest> | undefined): boolean {
    return proto3.util.equals(GetAgentsThreadRequest, a, b);
  }
}

/**
 * @generated from message protogen.GetAgentsThreadResponse
 */
export class GetAgentsThreadResponse extends Message<GetAgentsThreadResponse> {
  /**
   * @generated from field: repeated string events = 1;
   */
  events: string[] = [];

  /**
   * @generated from field: repeated string allMessages = 2;
   */
  allMessages: string[] = [];

  /**
   * @generated from field: repeated protogen.GetAgentsThreadResponse.AgentExecution executions = 3;
   */
  executions: GetAgentsThreadResponse_AgentExecution[] = [];

  /**
   * @generated from field: repeated protogen.GetAgentsThreadResponse.AddedEvent addedEvents = 4;
   */
  addedEvents: GetAgentsThreadResponse_AddedEvent[] = [];

  /**
   * @generated from field: repeated protogen.GetAgentsThreadResponse.AddedTask addedTasks = 5;
   */
  addedTasks: GetAgentsThreadResponse_AddedTask[] = [];

  /**
   * @generated from field: repeated protogen.GetAgentsThreadResponse.AddedDocument addedDocuments = 6;
   */
  addedDocuments: GetAgentsThreadResponse_AddedDocument[] = [];

  /**
   * @generated from field: bool clientOutputVisible = 7;
   */
  clientOutputVisible = false;

  /**
   * @generated from field: string playbookRef = 8;
   */
  playbookRef = "";

  constructor(data?: PartialMessage<GetAgentsThreadResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAgentsThreadResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "events", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "allMessages", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "executions", kind: "message", T: GetAgentsThreadResponse_AgentExecution, repeated: true },
    { no: 4, name: "addedEvents", kind: "message", T: GetAgentsThreadResponse_AddedEvent, repeated: true },
    { no: 5, name: "addedTasks", kind: "message", T: GetAgentsThreadResponse_AddedTask, repeated: true },
    { no: 6, name: "addedDocuments", kind: "message", T: GetAgentsThreadResponse_AddedDocument, repeated: true },
    { no: 7, name: "clientOutputVisible", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "playbookRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentsThreadResponse {
    return new GetAgentsThreadResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentsThreadResponse {
    return new GetAgentsThreadResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentsThreadResponse {
    return new GetAgentsThreadResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentsThreadResponse | PlainMessage<GetAgentsThreadResponse> | undefined, b: GetAgentsThreadResponse | PlainMessage<GetAgentsThreadResponse> | undefined): boolean {
    return proto3.util.equals(GetAgentsThreadResponse, a, b);
  }
}

/**
 * @generated from message protogen.GetAgentsThreadResponse.AgentExecution
 */
export class GetAgentsThreadResponse_AgentExecution extends Message<GetAgentsThreadResponse_AgentExecution> {
  /**
   * @generated from field: string model = 1;
   */
  model = "";

  /**
   * @generated from field: float latencySeconds = 2;
   */
  latencySeconds = 0;

  /**
   * @generated from field: int32 inputMessageCount = 3;
   */
  inputMessageCount = 0;

  /**
   * @generated from field: string metadataJson = 4;
   */
  metadataJson = "";

  constructor(data?: PartialMessage<GetAgentsThreadResponse_AgentExecution>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAgentsThreadResponse.AgentExecution";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "latencySeconds", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "inputMessageCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "metadataJson", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentsThreadResponse_AgentExecution {
    return new GetAgentsThreadResponse_AgentExecution().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentsThreadResponse_AgentExecution {
    return new GetAgentsThreadResponse_AgentExecution().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentsThreadResponse_AgentExecution {
    return new GetAgentsThreadResponse_AgentExecution().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentsThreadResponse_AgentExecution | PlainMessage<GetAgentsThreadResponse_AgentExecution> | undefined, b: GetAgentsThreadResponse_AgentExecution | PlainMessage<GetAgentsThreadResponse_AgentExecution> | undefined): boolean {
    return proto3.util.equals(GetAgentsThreadResponse_AgentExecution, a, b);
  }
}

/**
 * @generated from message protogen.GetAgentsThreadResponse.AddedEvent
 */
export class GetAgentsThreadResponse_AddedEvent extends Message<GetAgentsThreadResponse_AddedEvent> {
  /**
   * @generated from field: string eventRef = 1;
   */
  eventRef = "";

  /**
   * @generated from field: string eventStatus = 2;
   */
  eventStatus = "";

  /**
   * @generated from field: bool eventModified = 3;
   */
  eventModified = false;

  /**
   * @generated from field: string sourceEntityType = 4;
   */
  sourceEntityType = "";

  /**
   * @generated from field: string sourceEntityId = 5;
   */
  sourceEntityId = "";

  /**
   * @generated from field: int32 sourceEntityIndex = 6;
   */
  sourceEntityIndex = 0;

  constructor(data?: PartialMessage<GetAgentsThreadResponse_AddedEvent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAgentsThreadResponse.AddedEvent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "eventRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "eventStatus", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "eventModified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "sourceEntityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sourceEntityId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "sourceEntityIndex", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentsThreadResponse_AddedEvent {
    return new GetAgentsThreadResponse_AddedEvent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentsThreadResponse_AddedEvent {
    return new GetAgentsThreadResponse_AddedEvent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentsThreadResponse_AddedEvent {
    return new GetAgentsThreadResponse_AddedEvent().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentsThreadResponse_AddedEvent | PlainMessage<GetAgentsThreadResponse_AddedEvent> | undefined, b: GetAgentsThreadResponse_AddedEvent | PlainMessage<GetAgentsThreadResponse_AddedEvent> | undefined): boolean {
    return proto3.util.equals(GetAgentsThreadResponse_AddedEvent, a, b);
  }
}

/**
 * @generated from message protogen.GetAgentsThreadResponse.AddedTask
 */
export class GetAgentsThreadResponse_AddedTask extends Message<GetAgentsThreadResponse_AddedTask> {
  /**
   * @generated from field: string taskRef = 1;
   */
  taskRef = "";

  /**
   * @generated from field: string taskTitle = 2;
   */
  taskTitle = "";

  /**
   * @generated from field: string taskState = 3;
   */
  taskState = "";

  /**
   * @generated from field: string taskPriority = 4;
   */
  taskPriority = "";

  /**
   * @generated from field: string taskStage = 5;
   */
  taskStage = "";

  /**
   * @generated from field: string taskDueDate = 6;
   */
  taskDueDate = "";

  /**
   * @generated from field: string taskProject = 7;
   */
  taskProject = "";

  /**
   * @generated from field: string taskStageDate = 8;
   */
  taskStageDate = "";

  constructor(data?: PartialMessage<GetAgentsThreadResponse_AddedTask>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAgentsThreadResponse.AddedTask";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "taskRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "taskTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "taskState", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "taskPriority", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "taskStage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "taskDueDate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "taskProject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "taskStageDate", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentsThreadResponse_AddedTask {
    return new GetAgentsThreadResponse_AddedTask().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentsThreadResponse_AddedTask {
    return new GetAgentsThreadResponse_AddedTask().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentsThreadResponse_AddedTask {
    return new GetAgentsThreadResponse_AddedTask().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentsThreadResponse_AddedTask | PlainMessage<GetAgentsThreadResponse_AddedTask> | undefined, b: GetAgentsThreadResponse_AddedTask | PlainMessage<GetAgentsThreadResponse_AddedTask> | undefined): boolean {
    return proto3.util.equals(GetAgentsThreadResponse_AddedTask, a, b);
  }
}

/**
 * @generated from message protogen.GetAgentsThreadResponse.AddedDocument
 */
export class GetAgentsThreadResponse_AddedDocument extends Message<GetAgentsThreadResponse_AddedDocument> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string uuid = 2;
   */
  uuid = "";

  /**
   * @generated from field: string title = 3;
   */
  title = "";

  /**
   * @generated from field: string subtitle = 4;
   */
  subtitle = "";

  /**
   * @generated from field: protogen.DocumentType documentType = 5;
   */
  documentType = DocumentType.UNSPECIFIED;

  /**
   * @generated from field: string scope = 6;
   */
  scope = "";

  /**
   * @generated from field: string ownerRef = 7;
   */
  ownerRef = "";

  /**
   * @generated from field: string ownerDisplayName = 8;
   */
  ownerDisplayName = "";

  /**
   * @generated from field: int64 lastUpdatedSec = 9;
   */
  lastUpdatedSec = protoInt64.zero;

  /**
   * @generated from field: int32 unreadCount = 10;
   */
  unreadCount = 0;

  constructor(data?: PartialMessage<GetAgentsThreadResponse_AddedDocument>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.GetAgentsThreadResponse.AddedDocument";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "subtitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "documentType", kind: "enum", T: proto3.getEnumType(DocumentType) },
    { no: 6, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "ownerRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "ownerDisplayName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "lastUpdatedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "unreadCount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetAgentsThreadResponse_AddedDocument {
    return new GetAgentsThreadResponse_AddedDocument().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetAgentsThreadResponse_AddedDocument {
    return new GetAgentsThreadResponse_AddedDocument().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetAgentsThreadResponse_AddedDocument {
    return new GetAgentsThreadResponse_AddedDocument().fromJsonString(jsonString, options);
  }

  static equals(a: GetAgentsThreadResponse_AddedDocument | PlainMessage<GetAgentsThreadResponse_AddedDocument> | undefined, b: GetAgentsThreadResponse_AddedDocument | PlainMessage<GetAgentsThreadResponse_AddedDocument> | undefined): boolean {
    return proto3.util.equals(GetAgentsThreadResponse_AddedDocument, a, b);
  }
}

/**
 * @generated from message protogen.CreateAgentPromptRequest
 */
export class CreateAgentPromptRequest extends Message<CreateAgentPromptRequest> {
  /**
   * "playbook" or "family-prompt"
   *
   * @generated from field: string type = 1;
   */
  type = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * "enabled", "disabled", or "testing"
   *
   * @generated from field: string status = 3;
   */
  status = "";

  /**
   * @generated from field: protogen.ContentUpdates content = 4;
   */
  content?: ContentUpdates;

  /**
   * @generated from field: string scope = 5;
   */
  scope = "";

  /**
   * @generated from field: string configurationJson = 6;
   */
  configurationJson = "";

  /**
   * @generated from field: bool clientOutputVisible = 7;
   */
  clientOutputVisible = false;

  constructor(data?: PartialMessage<CreateAgentPromptRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateAgentPromptRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "content", kind: "message", T: ContentUpdates },
    { no: 5, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "configurationJson", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "clientOutputVisible", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAgentPromptRequest {
    return new CreateAgentPromptRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAgentPromptRequest {
    return new CreateAgentPromptRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAgentPromptRequest {
    return new CreateAgentPromptRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAgentPromptRequest | PlainMessage<CreateAgentPromptRequest> | undefined, b: CreateAgentPromptRequest | PlainMessage<CreateAgentPromptRequest> | undefined): boolean {
    return proto3.util.equals(CreateAgentPromptRequest, a, b);
  }
}

/**
 * @generated from message protogen.CreateAgentPromptResponse
 */
export class CreateAgentPromptResponse extends Message<CreateAgentPromptResponse> {
  /**
   * @generated from field: protogen.AgentPrompt prompt = 1;
   */
  prompt?: AgentPrompt;

  constructor(data?: PartialMessage<CreateAgentPromptResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateAgentPromptResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt", kind: "message", T: AgentPrompt },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateAgentPromptResponse {
    return new CreateAgentPromptResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateAgentPromptResponse {
    return new CreateAgentPromptResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateAgentPromptResponse {
    return new CreateAgentPromptResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateAgentPromptResponse | PlainMessage<CreateAgentPromptResponse> | undefined, b: CreateAgentPromptResponse | PlainMessage<CreateAgentPromptResponse> | undefined): boolean {
    return proto3.util.equals(CreateAgentPromptResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateAgentPromptRequest
 */
export class UpdateAgentPromptRequest extends Message<UpdateAgentPromptRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string type = 2;
   */
  type = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string status = 4;
   */
  status = "";

  /**
   * @generated from field: protogen.ContentUpdates content = 6;
   */
  content?: ContentUpdates;

  /**
   * @generated from field: string scope = 7;
   */
  scope = "";

  /**
   * @generated from field: string configurationJson = 8;
   */
  configurationJson = "";

  /**
   * @generated from field: bool updateConfiguration = 9;
   */
  updateConfiguration = false;

  /**
   * @generated from field: bool clientOutputVisible = 10;
   */
  clientOutputVisible = false;

  /**
   * @generated from field: bool updateClientOutputVisible = 11;
   */
  updateClientOutputVisible = false;

  constructor(data?: PartialMessage<UpdateAgentPromptRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateAgentPromptRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "content", kind: "message", T: ContentUpdates },
    { no: 7, name: "scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "configurationJson", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "updateConfiguration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "clientOutputVisible", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "updateClientOutputVisible", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAgentPromptRequest {
    return new UpdateAgentPromptRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAgentPromptRequest {
    return new UpdateAgentPromptRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAgentPromptRequest {
    return new UpdateAgentPromptRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAgentPromptRequest | PlainMessage<UpdateAgentPromptRequest> | undefined, b: UpdateAgentPromptRequest | PlainMessage<UpdateAgentPromptRequest> | undefined): boolean {
    return proto3.util.equals(UpdateAgentPromptRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateAgentPromptResponse
 */
export class UpdateAgentPromptResponse extends Message<UpdateAgentPromptResponse> {
  /**
   * @generated from field: protogen.AgentPrompt prompt = 1;
   */
  prompt?: AgentPrompt;

  constructor(data?: PartialMessage<UpdateAgentPromptResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateAgentPromptResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt", kind: "message", T: AgentPrompt },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateAgentPromptResponse {
    return new UpdateAgentPromptResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateAgentPromptResponse {
    return new UpdateAgentPromptResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateAgentPromptResponse {
    return new UpdateAgentPromptResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateAgentPromptResponse | PlainMessage<UpdateAgentPromptResponse> | undefined, b: UpdateAgentPromptResponse | PlainMessage<UpdateAgentPromptResponse> | undefined): boolean {
    return proto3.util.equals(UpdateAgentPromptResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListAgentPromptsRequest
 */
export class ListAgentPromptsRequest extends Message<ListAgentPromptsRequest> {
  /**
   * optional filter by type
   *
   * @generated from field: string type = 1;
   */
  type = "";

  /**
   * optional filter by status
   *
   * @generated from field: string status = 2;
   */
  status = "";

  constructor(data?: PartialMessage<ListAgentPromptsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAgentPromptsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentPromptsRequest {
    return new ListAgentPromptsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentPromptsRequest {
    return new ListAgentPromptsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentPromptsRequest {
    return new ListAgentPromptsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentPromptsRequest | PlainMessage<ListAgentPromptsRequest> | undefined, b: ListAgentPromptsRequest | PlainMessage<ListAgentPromptsRequest> | undefined): boolean {
    return proto3.util.equals(ListAgentPromptsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListAgentPromptsResponse
 */
export class ListAgentPromptsResponse extends Message<ListAgentPromptsResponse> {
  /**
   * @generated from field: repeated protogen.AgentPrompt prompts = 1;
   */
  prompts: AgentPrompt[] = [];

  constructor(data?: PartialMessage<ListAgentPromptsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAgentPromptsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompts", kind: "message", T: AgentPrompt, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentPromptsResponse {
    return new ListAgentPromptsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentPromptsResponse {
    return new ListAgentPromptsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentPromptsResponse {
    return new ListAgentPromptsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentPromptsResponse | PlainMessage<ListAgentPromptsResponse> | undefined, b: ListAgentPromptsResponse | PlainMessage<ListAgentPromptsResponse> | undefined): boolean {
    return proto3.util.equals(ListAgentPromptsResponse, a, b);
  }
}

/**
 * @generated from message protogen.FetchPromptInvocationRequest
 */
export class FetchPromptInvocationRequest extends Message<FetchPromptInvocationRequest> {
  /**
   * @generated from field: string promptRef = 1;
   */
  promptRef = "";

  constructor(data?: PartialMessage<FetchPromptInvocationRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.FetchPromptInvocationRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "promptRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchPromptInvocationRequest {
    return new FetchPromptInvocationRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchPromptInvocationRequest {
    return new FetchPromptInvocationRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchPromptInvocationRequest {
    return new FetchPromptInvocationRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FetchPromptInvocationRequest | PlainMessage<FetchPromptInvocationRequest> | undefined, b: FetchPromptInvocationRequest | PlainMessage<FetchPromptInvocationRequest> | undefined): boolean {
    return proto3.util.equals(FetchPromptInvocationRequest, a, b);
  }
}

/**
 * @generated from message protogen.FetchPromptInvocationResponse
 */
export class FetchPromptInvocationResponse extends Message<FetchPromptInvocationResponse> {
  /**
   * @generated from field: repeated protogen.FetchPromptInvocationResponse.PromptInvocation invocations = 1;
   */
  invocations: FetchPromptInvocationResponse_PromptInvocation[] = [];

  constructor(data?: PartialMessage<FetchPromptInvocationResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.FetchPromptInvocationResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "invocations", kind: "message", T: FetchPromptInvocationResponse_PromptInvocation, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchPromptInvocationResponse {
    return new FetchPromptInvocationResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchPromptInvocationResponse {
    return new FetchPromptInvocationResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchPromptInvocationResponse {
    return new FetchPromptInvocationResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FetchPromptInvocationResponse | PlainMessage<FetchPromptInvocationResponse> | undefined, b: FetchPromptInvocationResponse | PlainMessage<FetchPromptInvocationResponse> | undefined): boolean {
    return proto3.util.equals(FetchPromptInvocationResponse, a, b);
  }
}

/**
 * @generated from message protogen.FetchPromptInvocationResponse.PromptInvocation
 */
export class FetchPromptInvocationResponse_PromptInvocation extends Message<FetchPromptInvocationResponse_PromptInvocation> {
  /**
   * @generated from field: string threadRef = 1;
   */
  threadRef = "";

  /**
   * @generated from field: string type = 2;
   */
  type = "";

  /**
   * @generated from field: int64 createdSec = 3;
   */
  createdSec = protoInt64.zero;

  /**
   * @generated from field: string taskRef = 4;
   */
  taskRef = "";

  /**
   * @generated from field: string taskTitle = 5;
   */
  taskTitle = "";

  /**
   * @generated from field: string taskStage = 6;
   */
  taskStage = "";

  /**
   * @generated from field: protogen.AccountStub runner = 7;
   */
  runner?: AccountStub;

  constructor(data?: PartialMessage<FetchPromptInvocationResponse_PromptInvocation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.FetchPromptInvocationResponse.PromptInvocation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "createdSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "taskRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "taskTitle", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "taskStage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "runner", kind: "message", T: AccountStub },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FetchPromptInvocationResponse_PromptInvocation {
    return new FetchPromptInvocationResponse_PromptInvocation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FetchPromptInvocationResponse_PromptInvocation {
    return new FetchPromptInvocationResponse_PromptInvocation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FetchPromptInvocationResponse_PromptInvocation {
    return new FetchPromptInvocationResponse_PromptInvocation().fromJsonString(jsonString, options);
  }

  static equals(a: FetchPromptInvocationResponse_PromptInvocation | PlainMessage<FetchPromptInvocationResponse_PromptInvocation> | undefined, b: FetchPromptInvocationResponse_PromptInvocation | PlainMessage<FetchPromptInvocationResponse_PromptInvocation> | undefined): boolean {
    return proto3.util.equals(FetchPromptInvocationResponse_PromptInvocation, a, b);
  }
}

/**
 * @generated from message protogen.InterruptAgentThreadRequest
 */
export class InterruptAgentThreadRequest extends Message<InterruptAgentThreadRequest> {
  /**
   * @generated from field: string threadRef = 1;
   */
  threadRef = "";

  constructor(data?: PartialMessage<InterruptAgentThreadRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.InterruptAgentThreadRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InterruptAgentThreadRequest {
    return new InterruptAgentThreadRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InterruptAgentThreadRequest {
    return new InterruptAgentThreadRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InterruptAgentThreadRequest {
    return new InterruptAgentThreadRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InterruptAgentThreadRequest | PlainMessage<InterruptAgentThreadRequest> | undefined, b: InterruptAgentThreadRequest | PlainMessage<InterruptAgentThreadRequest> | undefined): boolean {
    return proto3.util.equals(InterruptAgentThreadRequest, a, b);
  }
}

/**
 * @generated from message protogen.InterruptAgentThreadResponse
 */
export class InterruptAgentThreadResponse extends Message<InterruptAgentThreadResponse> {
  /**
   * @generated from field: string threadRef = 1;
   */
  threadRef = "";

  constructor(data?: PartialMessage<InterruptAgentThreadResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.InterruptAgentThreadResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InterruptAgentThreadResponse {
    return new InterruptAgentThreadResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InterruptAgentThreadResponse {
    return new InterruptAgentThreadResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InterruptAgentThreadResponse {
    return new InterruptAgentThreadResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InterruptAgentThreadResponse | PlainMessage<InterruptAgentThreadResponse> | undefined, b: InterruptAgentThreadResponse | PlainMessage<InterruptAgentThreadResponse> | undefined): boolean {
    return proto3.util.equals(InterruptAgentThreadResponse, a, b);
  }
}

/**
 * @generated from message protogen.RetryAgentThreadRequest
 */
export class RetryAgentThreadRequest extends Message<RetryAgentThreadRequest> {
  /**
   * @generated from field: string threadRef = 1;
   */
  threadRef = "";

  constructor(data?: PartialMessage<RetryAgentThreadRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RetryAgentThreadRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RetryAgentThreadRequest {
    return new RetryAgentThreadRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RetryAgentThreadRequest {
    return new RetryAgentThreadRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RetryAgentThreadRequest {
    return new RetryAgentThreadRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RetryAgentThreadRequest | PlainMessage<RetryAgentThreadRequest> | undefined, b: RetryAgentThreadRequest | PlainMessage<RetryAgentThreadRequest> | undefined): boolean {
    return proto3.util.equals(RetryAgentThreadRequest, a, b);
  }
}

/**
 * @generated from message protogen.RetryAgentThreadResponse
 */
export class RetryAgentThreadResponse extends Message<RetryAgentThreadResponse> {
  /**
   * @generated from field: string threadRef = 1;
   */
  threadRef = "";

  constructor(data?: PartialMessage<RetryAgentThreadResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.RetryAgentThreadResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RetryAgentThreadResponse {
    return new RetryAgentThreadResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RetryAgentThreadResponse {
    return new RetryAgentThreadResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RetryAgentThreadResponse {
    return new RetryAgentThreadResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RetryAgentThreadResponse | PlainMessage<RetryAgentThreadResponse> | undefined, b: RetryAgentThreadResponse | PlainMessage<RetryAgentThreadResponse> | undefined): boolean {
    return proto3.util.equals(RetryAgentThreadResponse, a, b);
  }
}

/**
 * @generated from message protogen.ToggleAgentPromptRequest
 */
export class ToggleAgentPromptRequest extends Message<ToggleAgentPromptRequest> {
  /**
   * @generated from field: string promptRef = 1;
   */
  promptRef = "";

  /**
   * @generated from field: bool isEnabled = 2;
   */
  isEnabled = false;

  constructor(data?: PartialMessage<ToggleAgentPromptRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ToggleAgentPromptRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "promptRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "isEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ToggleAgentPromptRequest {
    return new ToggleAgentPromptRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ToggleAgentPromptRequest {
    return new ToggleAgentPromptRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ToggleAgentPromptRequest {
    return new ToggleAgentPromptRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ToggleAgentPromptRequest | PlainMessage<ToggleAgentPromptRequest> | undefined, b: ToggleAgentPromptRequest | PlainMessage<ToggleAgentPromptRequest> | undefined): boolean {
    return proto3.util.equals(ToggleAgentPromptRequest, a, b);
  }
}

/**
 * @generated from message protogen.ToggleAgentPromptResponse
 */
export class ToggleAgentPromptResponse extends Message<ToggleAgentPromptResponse> {
  /**
   * @generated from field: protogen.AgentPrompt prompt = 1;
   */
  prompt?: AgentPrompt;

  constructor(data?: PartialMessage<ToggleAgentPromptResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ToggleAgentPromptResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt", kind: "message", T: AgentPrompt },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ToggleAgentPromptResponse {
    return new ToggleAgentPromptResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ToggleAgentPromptResponse {
    return new ToggleAgentPromptResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ToggleAgentPromptResponse {
    return new ToggleAgentPromptResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ToggleAgentPromptResponse | PlainMessage<ToggleAgentPromptResponse> | undefined, b: ToggleAgentPromptResponse | PlainMessage<ToggleAgentPromptResponse> | undefined): boolean {
    return proto3.util.equals(ToggleAgentPromptResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListAgentToolsRequest
 */
export class ListAgentToolsRequest extends Message<ListAgentToolsRequest> {
  constructor(data?: PartialMessage<ListAgentToolsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAgentToolsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentToolsRequest {
    return new ListAgentToolsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentToolsRequest {
    return new ListAgentToolsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentToolsRequest {
    return new ListAgentToolsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentToolsRequest | PlainMessage<ListAgentToolsRequest> | undefined, b: ListAgentToolsRequest | PlainMessage<ListAgentToolsRequest> | undefined): boolean {
    return proto3.util.equals(ListAgentToolsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListAgentToolsResponse
 */
export class ListAgentToolsResponse extends Message<ListAgentToolsResponse> {
  /**
   * @generated from field: repeated protogen.ListAgentToolsResponse.AgentTool tools = 1;
   */
  tools: ListAgentToolsResponse_AgentTool[] = [];

  constructor(data?: PartialMessage<ListAgentToolsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAgentToolsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tools", kind: "message", T: ListAgentToolsResponse_AgentTool, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentToolsResponse {
    return new ListAgentToolsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentToolsResponse {
    return new ListAgentToolsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentToolsResponse {
    return new ListAgentToolsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentToolsResponse | PlainMessage<ListAgentToolsResponse> | undefined, b: ListAgentToolsResponse | PlainMessage<ListAgentToolsResponse> | undefined): boolean {
    return proto3.util.equals(ListAgentToolsResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListAgentToolsResponse.AgentTool
 */
export class ListAgentToolsResponse_AgentTool extends Message<ListAgentToolsResponse_AgentTool> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string displayName = 2;
   */
  displayName = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  constructor(data?: PartialMessage<ListAgentToolsResponse_AgentTool>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListAgentToolsResponse.AgentTool";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "displayName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListAgentToolsResponse_AgentTool {
    return new ListAgentToolsResponse_AgentTool().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListAgentToolsResponse_AgentTool {
    return new ListAgentToolsResponse_AgentTool().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListAgentToolsResponse_AgentTool {
    return new ListAgentToolsResponse_AgentTool().fromJsonString(jsonString, options);
  }

  static equals(a: ListAgentToolsResponse_AgentTool | PlainMessage<ListAgentToolsResponse_AgentTool> | undefined, b: ListAgentToolsResponse_AgentTool | PlainMessage<ListAgentToolsResponse_AgentTool> | undefined): boolean {
    return proto3.util.equals(ListAgentToolsResponse_AgentTool, a, b);
  }
}

/**
 * @generated from message protogen.ListFailedAgentThreadsRequest
 */
export class ListFailedAgentThreadsRequest extends Message<ListFailedAgentThreadsRequest> {
  /**
   * @generated from field: int32 pageSize = 1;
   */
  pageSize = 0;

  /**
   * @generated from field: int64 cursor = 2;
   */
  cursor = protoInt64.zero;

  /**
   * @generated from field: string threadRef = 3;
   */
  threadRef = "";

  constructor(data?: PartialMessage<ListFailedAgentThreadsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListFailedAgentThreadsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pageSize", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "cursor", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "threadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFailedAgentThreadsRequest {
    return new ListFailedAgentThreadsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFailedAgentThreadsRequest {
    return new ListFailedAgentThreadsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFailedAgentThreadsRequest {
    return new ListFailedAgentThreadsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListFailedAgentThreadsRequest | PlainMessage<ListFailedAgentThreadsRequest> | undefined, b: ListFailedAgentThreadsRequest | PlainMessage<ListFailedAgentThreadsRequest> | undefined): boolean {
    return proto3.util.equals(ListFailedAgentThreadsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListFailedAgentThreadsResponse
 */
export class ListFailedAgentThreadsResponse extends Message<ListFailedAgentThreadsResponse> {
  /**
   * @generated from field: repeated protogen.ListFailedAgentThreadsResponse.FailedAgentThread threads = 1;
   */
  threads: ListFailedAgentThreadsResponse_FailedAgentThread[] = [];

  /**
   * @generated from field: int64 nextCursor = 2;
   */
  nextCursor = protoInt64.zero;

  constructor(data?: PartialMessage<ListFailedAgentThreadsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListFailedAgentThreadsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threads", kind: "message", T: ListFailedAgentThreadsResponse_FailedAgentThread, repeated: true },
    { no: 2, name: "nextCursor", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFailedAgentThreadsResponse {
    return new ListFailedAgentThreadsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFailedAgentThreadsResponse {
    return new ListFailedAgentThreadsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFailedAgentThreadsResponse {
    return new ListFailedAgentThreadsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListFailedAgentThreadsResponse | PlainMessage<ListFailedAgentThreadsResponse> | undefined, b: ListFailedAgentThreadsResponse | PlainMessage<ListFailedAgentThreadsResponse> | undefined): boolean {
    return proto3.util.equals(ListFailedAgentThreadsResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListFailedAgentThreadsResponse.FailedAgentThread
 */
export class ListFailedAgentThreadsResponse_FailedAgentThread extends Message<ListFailedAgentThreadsResponse_FailedAgentThread> {
  /**
   * @generated from field: string threadRef = 1;
   */
  threadRef = "";

  /**
   * @generated from field: string entityType = 2;
   */
  entityType = "";

  /**
   * @generated from field: int64 creationSec = 3;
   */
  creationSec = protoInt64.zero;

  /**
   * @generated from field: string creatorName = 4;
   */
  creatorName = "";

  /**
   * @generated from field: string inboxType = 5;
   */
  inboxType = "";

  /**
   * @generated from field: string familyName = 6;
   */
  familyName = "";

  /**
   * @generated from field: string status = 7;
   */
  status = "";

  /**
   * @generated from field: repeated string errors = 8;
   */
  errors: string[] = [];

  /**
   * @generated from field: string playbookName = 9;
   */
  playbookName = "";

  constructor(data?: PartialMessage<ListFailedAgentThreadsResponse_FailedAgentThread>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListFailedAgentThreadsResponse.FailedAgentThread";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "threadRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entityType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "creationSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "creatorName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "inboxType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "familyName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "errors", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "playbookName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFailedAgentThreadsResponse_FailedAgentThread {
    return new ListFailedAgentThreadsResponse_FailedAgentThread().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFailedAgentThreadsResponse_FailedAgentThread {
    return new ListFailedAgentThreadsResponse_FailedAgentThread().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFailedAgentThreadsResponse_FailedAgentThread {
    return new ListFailedAgentThreadsResponse_FailedAgentThread().fromJsonString(jsonString, options);
  }

  static equals(a: ListFailedAgentThreadsResponse_FailedAgentThread | PlainMessage<ListFailedAgentThreadsResponse_FailedAgentThread> | undefined, b: ListFailedAgentThreadsResponse_FailedAgentThread | PlainMessage<ListFailedAgentThreadsResponse_FailedAgentThread> | undefined): boolean {
    return proto3.util.equals(ListFailedAgentThreadsResponse_FailedAgentThread, a, b);
  }
}

